
<ng-template #itemsTemplate let-info="info" let-first="first" let-idx="idx">
  <div class="info" [ngClass]="{noPadding: noPadding}">
    <div class="title_bar" *ngIf="!singleSectionOnly" (click)="toggleInfoBox($event, info.id)">
      <icon [matIcon]="(infoExpandedStates[info.id] === 'collapse' ? 'arrow_right' : 'arrow_drop_down')"></icon>
      <div class="title">
        <ng-container *ngIf="sectionTitleTemplate" [ngTemplateOutlet]="sectionTitleTemplate" [ngTemplateOutletContext]="{info:info}"></ng-container>
        <div *ngIf="!sectionTitleTemplate && info.title" [innerHTML]="helpers.strWithBreak(info.title)"></div>
      </div>

      <type-select-dropdown *ngIf="entityType" 
        [ids]="info.entityTypeIds || []"
        [types]="entityTypesMap"
        [entityType]="entityType"
        (selectIds)="updateEntityIds(info, $event)"
      ></type-select-dropdown>

      <div class="action-{{idx}}" *ngIf="(!first || canDeleteFirst) && !readOnly" [matMenuTriggerFor]="sectionMenu">
        <icon class="more" matIcon="more_vert"></icon>
      </div>
      <mat-menu #sectionMenu="matMenu" xPosition="before">
        <button mat-menu-item (click)="deleteSection($event, info, 'action-'+idx)">Delete section</button>
        <button mat-menu-item (click)="duplicateSection.emit(info)">Duplicate section</button>
      </mat-menu>
    </div>
    <div class="items_panel" [@drop]="infoExpandedStates[info.id]">
      <div class="event_info_items"
        [id]="'section_'+idx"
        cdkDropList
        [cdkDropListData]="info.items"
        (cdkDropListDropped)="dropItem.emit($event)"
        [cdkDropListConnectedTo]="connectedList"
      >
        <div cdkDrag [cdkDragData]="item" *ngFor="let item of info.items; trackBy: trackById; index as k">
          <div class="item_container" [ngClass]="{singleItem:info?.items?.length === 1}" >
            <div class="invisible_bar smooth" cdkDragHandle></div>
            <div class="indicator_container smooth">
              <icon class="item_handle" matIcon="drag_indicator"></icon>
            </div>
            <div class="item" [ngClass]="{closed: itemExpandedStates[item.id] === 'collapse'}">
              <div class="open_dialog_wrapper" (click)="toggleInfo($event, item.id)">
                <div class="subtitle_bar">
                  <icon  [matIcon]="(itemExpandedStates[item.id] === 'collapse' ? 'arrow_right' : 'arrow_drop_down')"></icon>
                  <div class="item_title" (click)="emitOpenItem($event, item, info)">
                    <div *ngIf="item.name" [innerHTML]="helpers.strWithBreak(item.name)"></div>
                    <div *ngIf="!item.name" class="placeholder">{{ namePlaceholderOverride || 'Item name' }}</div>
                  </div>
                  <div style="flex:1"></div>
                </div>
                <div class="smooth desc" [ngClass]="{empty: !item.description, collapse: itemExpandedStates[item.id] === 'collapse', expand: itemExpandedStates[item.id] !== 'collapse' }">
                  <span *ngIf="item.description" (click)="emitOpenItem($event, item, info)" [innerHTML]="helpers.strWithBreak(item.description)"></span>
                  <span *ngIf="!item.description" (click)="emitOpenItem($event, item, info)" class="placeholder">{{ descriptionPlaceholderOverride || item.placeholder || "Description" }}</span>
                  <hr class="file_divider" *ngIf="item.files?.length">
                  <div class="files" *ngIf="item.files?.length">
                    <h5 class="files_header">Files</h5>
                    <file-link *ngFor="let file of item.files"
                      (click)="$event.stopPropagation()"
                      [file]="file"
                      [onlyLink]="true"
                    ></file-link>
                  </div>
                  <div class="files" *ngIf="item.assetIds?.length">
                    <h5 class="files_header">Assets</h5>
                    <asset-link *ngFor="let asset of item.assetIds | idsToItems:assets"
                      (click)="$event.stopPropagation()"
                      [asset]="asset"
                      [onlyLink]="true"
                    ></asset-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="no_item" *ngIf="info.items.length==0">{{ noItemsMessage }}</div>
      </div>
      <div class="btns" *ngIf="!readOnly">
        <button class="secondary" (click)="addItem.emit(info)">+ Add an item</button>
        <!--<button class="add in">+ Add an item from list</button>-->
      </div>
    </div>
  </div>
</ng-template>

<div class="information_panel" *ngIf="information && singleSectionOnly">
  <div class="info_container" [ngClass]="{readonly: readOnly}" *ngFor="let info of information; trackBy: trackBySection; index as idx; first as first">
    <ng-container [ngTemplateOutlet]="itemsTemplate" [ngTemplateOutletContext]="{idx: idx, first: first, info: info}"></ng-container>
  </div>
</div>

<ng-container *ngIf="readOnly && !singleSectionOnly && !!information">
  <div class="information_panel">
    <div class="info_container" [ngClass]="{readonly: readOnly}" *ngFor="let info of information; trackBy: trackBySection; index as idx; first as first"
    >
      <ng-container [ngTemplateOutlet]="itemsTemplate" [ngTemplateOutletContext]="{idx: idx, first: first, info: info}"></ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!readOnly && !!information && !singleSectionOnly">
  <div class="information_panel"
    cdkDropList
    [cdkDropListData]="information"
    (cdkDropListDropped)="dropSection.emit($event)"
  >
    <div class="info_container"
      [ngClass]="{readonly: readOnly}"
      cdkDropListGroup
      cdkDrag
      [cdkDragData]="info"
      *ngFor="let info of information; trackBy: trackBySection; index as idx; first as first"
    >
      <div class="indicator_container">
        <icon class="item_handle smooth" cdkDragHandle matIcon="drag_indicator"></icon>
      </div>
      <ng-container [ngTemplateOutlet]="itemsTemplate" [ngTemplateOutletContext]="{idx: idx, first: first, info: info}"></ng-container>
    </div>
  </div>
  <button mat-button class="large" *ngIf="!readOnly && !singleSectionOnly" (click)="addSection.emit()">+ Add a section</button>
</ng-container>

